<template>
  <div>
    <div
      v-html="sanitizedContent"
      data-testid="text-widget-content"
      class="body1"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'TextContent',

  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  computed: {
    sanitizedContent() {
      const content = this.data?.content ?? ''
      return this.$sanitize(content)
    },
  },
}
</script>
